/**
 * AlphaSense Agent - Variable Definitions
 *
 * Keywords AI Keys:
 * - ALPHASENSE_INTRO
 * - ALPHASENSE_TOOLS_PREAMBLE
 * - ALPHASENSE_TOOLS_POSTAMBLE
 * - ALPHASENSE_SUGGESTIONS
 * - ALPHASENSE_CONTEXT_NOTE
 * - ALPHASENSE_EVALUATION
 */
export const ALPHASENSE_VARIABLES = {
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};
export const ALPHASENSE_PROMPT_KEYS = {
    intro: 'ALPHASENSE_INTRO',
    toolsPreamble: 'ALPHASENSE_TOOLS_PREAMBLE',
    toolsPostamble: 'ALPHASENSE_TOOLS_POSTAMBLE',
    suggestions: 'ALPHASENSE_SUGGESTIONS',
    contextNote: 'ALPHASENSE_CONTEXT_NOTE',
    evaluation: 'ALPHASENSE_EVALUATION',
};
export const ALPHASENSE_PROMPT_CONFIG = {
    agentName: 'alphaSense',
    sections: {
        intro: { keywordsKey: ALPHASENSE_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: ALPHASENSE_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: ALPHASENSE_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: ALPHASENSE_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: ALPHASENSE_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: ALPHASENSE_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: ALPHASENSE_VARIABLES,
};
